import './Shop.scss'

import React, {Component} from 'react'
import moment from 'moment'
import {connect} from 'react-redux';
import RangeSelector from '../components/RangeSelector';
import { push } from 'connected-react-router'
import {arrayToObject} from '../helper'
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router-dom';

import { PaymentOptions } from '../components'

import * as actions from '../actions'


import './OrderPage.scss';

class OrderStatus extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.props.loadOrderStatus(
            this.props.match.params.order_code,
            this.props.match.params.order_signature 
        )
    }

    render() {
        const props = this.props;

        return (
            <article className={"shop-page page"}>
                <section className="section gray-section on-screen">
                <div className="section-content">
                    <div className="container">
                        <h1 className="text-center shop-title">Bestellstatus</h1>
                        <div className="shop">
                            <div className="shop-content">
                                <div className="shop-content-box">
                                    <h2 className="shop-content-box-title">Fahrsicherheitstraining</h2>
                                    {props.orderStatus.type_code == "voucher" && (
                                        <dl className="attribute-list">
                                            <dt className="attribute-list-name">Name:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.firstName} {props.orderStatus.lastName}</dd>
                                            <dt className="attribute-list-name">Betrag:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.total} €</dd>
                                            <dt className="attribute-list-name">Status:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.status}</dd>
                                        </dl>
                                    )}
                                    
                                    {props.orderStatus.type_code == "booking" && (
                                        <dl className="attribute-list">
                                            <dt className="attribute-list-name">Name:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.firstName} {props.orderStatus.lastName}</dd>
                                            <dt className="attribute-list-name">Teilnehmer:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.quantity}</dd>
                                            <dt className="attribute-list-name">Fahrzeugart:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.vehicleType}</dd>
                                            <dt className="attribute-list-name">Trainingsart:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.trainingType}</dd>
                                            <dt className="attribute-list-name">Status:</dt>
                                            <dd className="attribute-list-value">{props.orderStatus.status}</dd>
                                        </dl>
                                    )}
                                </div>
                                {props.orderStatus.statusCode == "open" && (
                                <form onSubmit={(e) => {
                                    e.preventDefault()
                                    props.payOrder(
                                        props.match.params.order_code,
                                        props.match.params.order_signature
                                    )
                                }}>
                                    <div className="shop-content-box">
                                        <h2 className="shop-content-box-title">Zahlung</h2>
                                        <p>
                                            Ihre Bestellung wurde noch nicht bezahlt. <br />
                                        </p>

                                        <PaymentOptions paymentOption={props.paymentOption} onChange={(paymentOption) => {
                                            props.onPaymentMethodChanged(paymentOption)
                                        }} />
                                    </div>
                                    <p className="button-bar">
                                        <button type="submit" className="btn white-btn" style={{float: 'right'}}>bezahlen</button>
                                    </p>
                                </form>
                                )}
                            </div>
                            <div className="shop-sidebar shop-sidebar--order">
                                <h2 className="shop-sidebar-title">Rechnungsinformationen</h2>
                                <table className="invoice-table" style={{width: '100%'}}>
                                    <tbody className="invoice-table-items">
                                        
                                    </tbody>
                                    <tbody className="invoice-table-subtotals">
                                        <tr>
                                            <th>Netto:</th>
                                            <td className="text-right"> {parseFloat(props.orderStatus.net).toFixed(2)} €</td>
                                        </tr>
                                        <tr>
                                            <th>MwSt:</th>
                                            <td className="text-right"> {parseFloat(props.orderStatus.tax).toFixed(2)} €</td>
                                        </tr>
                                    </tbody>
                                    <tfoot className="invoice-table-totals">
                                        <tr>
                                            <th>Gesamtsumme:</th>
                                            <td className="text-right"> {parseFloat(props.orderStatus.total).toFixed(2)} €</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </article>
        )
    }
}

const mapStateToProps = state => {
    return {
        orderStatus: state.orderStatus,
        paymentOption: state.order.paymentOption,
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        onPaymentMethodChanged: (params) => dispatch({type: 'ORDER_PAYMENT_OPTION_CHANGED', paymentOption: params}),
        loadOrderStatus: (code, signature) => {
            dispatch(actions.loadOrderStatus(code, signature))
        },
        payOrder: (code, signature) => dispatch(actions.payOrder(code, signature))
    }
}

export default withRouter(connect(
    mapStateToProps, 
    mapDispatchToProps
)(OrderStatus))


// WEBPACK FOOTER //
// ./src/pages/OrderStatus.jsx